"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=capture.thumbnail.js.map